import Vue from 'vue';
import Vuex from 'vuex';
import customerModule from './modules/customer';
import customersModule from './modules/customers';
import loaderModule from './modules/loader';
import localStorageModule from './modules/localStorage';
import formsModule from './modules/forms';
import formModule from './modules/form';
import codemanager from './modules/codemanager';
import snippetsModule from './modules/snippets';
import ExtraModules from '@/lib/loader-modules';
import autoSuggestModule from './modules/autosuggest';
import customerForms from './modules/customer-forms';
import menu from './modules/menu';
import ellipsisResize from './modules/ellipsisresize';

import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import createMultiTabState from 'vuex-multi-tab-state';
import { oidcSettings } from '../config/oidc';

import vendorModule from '@/sections/vendors/vendors-module.js';
import vendorIntegrationsModule from '@/sections/vendors/integrations/integrations-module.js';
import historyLogs from './modules/historyLogs';
import { LoggingModule, UserInfoModule } from 'vue-ui-layout';
export * from './modules/mutation-types';

let storeModules = {};
ExtraModules.forEach(module => {
	if (module != undefined) {
		storeModules[module.name] = module;
	}
});

Vue.use(Vuex);
export default new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	modules: {
		customer: customerModule,
		customers: customersModule,
		loader: loaderModule,
		localStorage: localStorageModule,
		forms: formsModule,
		form: formModule,
		codemanager: codemanager,
		snippets: snippetsModule,
		autosuggest: autoSuggestModule,
		customerForms: customerForms,
		ellipsisResize: ellipsisResize,
		vendor: vendorModule,
		vendorIntegrations: vendorIntegrationsModule,
		historyLogs,
		logging: LoggingModule,
		user: UserInfoModule,
		menu,
		oidcStore: vuexOidcCreateStoreModule(oidcSettings(), {
			namespaced: true,
			isAuthenticatedBy: 'access_token'
		}),
		...storeModules
	},
	state: {
		screenSize: {
			desktop: true,
			mobile: false,
			tablet: false,
			smallTablet: false
		},
		currentPage: '' // used to set the current page and to set is-active on action-set-nav items. Set page on the actions-set-nav
	},
	mutations: {
		setScreenSize(state, value) {
			state.screenSize.desktop = value >= 1200;
			state.screenSize.mobile = value < 768;
			state.screenSize.smallTablet = value >= 768 && value < 992;
			state.screenSize.tablet = value >= 992 && value < 1200;
		},
		setCurrentPage(state, value) {
			state.currentPage = value;
		}
	},
	getters: {
		screenSize: state => state.screenSize
	},
	plugins: [
		createMultiTabState({
			key: `localStorage:${window.location.origin}`,
			statesPaths: [
				'localStorage.customer',
				'localStorage.customers',
				'localStorage.permissions',
				'localStorage.roles',
				'localStorage.users',
				'localStorage.breadcrumbs'
			]
		})
	]
});
